import React, { Suspense } from "react";
import ReactDOM from "react-dom";

import SuspenseFallbackComponent from "../common/components/SuspenseFallbackComponent";
import LayoutModal from "../common/components/layouts/LayoutModal";
import BillingStateSelectionContainer from "../gig/book-this-gig/components/utils/BillingCountrySelectionContainer";
import DropdownIcon from "../../lib/components/Icons/DropDownIcon";

function CurrencyModalComponent({
  isModalActive,
  setIsModalActive,
  className,
  currencyCode,
  currencySymbol,
  allCountries,
  selectedBillingCountry,
  setSelectedBillingCountry,
  isLoading,
}) {
  function ShimmerLoader() {
    return (
      <div className="w-full">
        <div className="mr-2 mb-2 w-4/12 h-6 rounded-lg shimmer"></div>
      </div>
    );
  }
  return (
    <>
      <div
        className="flex items-center py-3 px-5 h-10 text-center rounded-lg border cursor-pointer w-fit border-secondary-dark-100"
        onClick={() => {
          setIsModalActive(true);
        }}
      >
        <p className="w-full text-sm font-medium tracking-tight text-space-200">
          {currencySymbol} {currencyCode}
        </p>

        <div className="ml-2 w-4">
          <DropdownIcon />
        </div>
      </div>
      {isModalActive && isModalActive !== "BreakUp" && (
        <Suspense fallback={<SuspenseFallbackComponent />}>
          {isModalActive &&
            ReactDOM.createPortal(
              <LayoutModal
                className={"flex-col justify-between sm:flex md:h-160 md:w-136"}
                showModal={isModalActive}
                setShowModal={setIsModalActive}
                showCloseIcon={true}
                shouldCloseOnBackgroundClick={true}
                closeButtonClassnames="top-4 left-6"
                id="currency-modal"
              >
                <div className="flex flex-col justify-center items-center pt-3 space-y-2 border-b border-space-30">
                  <p className="mb-4 font-serif text-base font-semibold tracking-tight text-space-200">
                    Choose your Country
                  </p>
                </div>
                <section className="flex overflow-y-auto flex-col flex-grow px-8 pb-5 space-y-6">
                  {/* Body component */}
                  <BillingStateSelectionContainer
                    className={""}
                    setModalState={setIsModalActive}
                    Countries={allCountries}
                    selectedBillingCountry={selectedBillingCountry.name}
                    setSelectedBillingCountry={setSelectedBillingCountry}
                    restSelectedBillingState={() => {}}
                    placeholder="Search Your Country"
                  />
                  {isLoading && [...new Array(10)].map(() => ShimmerLoader())}
                </section>
              </LayoutModal>,
              document.getElementById("modal")
            )}
        </Suspense>
      )}
    </>
  );
}

export default CurrencyModalComponent;
